module.exports = __webpack_public_path__ + "img/fp-logo-v.2e4d7d52.png";